'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Set as ImmutableSet } from 'immutable';
import { Flex } from 'foundations-components/components/Flex';
import { selectFilteredReportCount } from '../../selectors/reportsSelector';
import BulkDeleteAction from './bulkDelete/BulkDeleteAction';
import BulkChangeOwnerAction from './BulkChangeOwnerAction';
import BulkAddToDashboardAction from './BulkAddToDashboardAction';
import BulkManageAccessAction from './BulkManageAccessAction';
import BulkSetBusinessUnitAction from './BulkSetBusinessUnitAction';
import BulkRestoreAction from './BulkRestoreAction';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { useSelectedRows } from '../../redux/selectedRows';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportBulkActions = props => {
  const {
    actionableRows,
    isRestore = false
  } = props;
  const {
    selectedRows,
    selectAll,
    selectedAll,
    selectAllDisabled,
    selectedEverything,
    selectEverything
  } = useSelectedRows({
    actionableRows
  });
  const filteredReportCount = useSelector(selectFilteredReportCount);
  const selectedCount = isRestore || !selectedEverything ? selectedRows.size : filteredReportCount;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "400",
    alignItems: "center",
    children: [props.children ? props.children : /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'reports.table.header.selected',
        options: {
          selectedCount
        }
      })
    }), isRestore ? /*#__PURE__*/_jsx(BulkRestoreAction, {
      selectedRows: selectedRows
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [selectedAll && !selectedEverything && /*#__PURE__*/_jsx(Link, {
        onClick: selectEverything,
        paddingInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.table.selectEverything.notSelected.ctaText",
          options: {
            totalCount: filteredReportCount
          }
        })
      }), !selectedAll && !selectedEverything && /*#__PURE__*/_jsx(Link, {
        disabled: selectAllDisabled,
        onClick: selectAll,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'reports.reportCard.selectAll'
        })
      }), /*#__PURE__*/_jsx(BulkDeleteAction, {
        selectedRows: selectedRows,
        selectedEverything: selectedEverything
      }), /*#__PURE__*/_jsx(BulkChangeOwnerAction, {
        selectedRows: selectedRows,
        selectedEverything: selectedEverything
      }), /*#__PURE__*/_jsx(BulkManageAccessAction, {
        selectedRows: selectedRows,
        selectedEverything: selectedEverything
      }), /*#__PURE__*/_jsx(BulkAddToDashboardAction, {
        selectedRows: selectedRows,
        selectedEverything: selectedEverything
      }), /*#__PURE__*/_jsx(BulkSetBusinessUnitAction, {
        selectedRows: selectedRows,
        selectedEverything: selectedEverything
      })]
    })]
  });
};
ReportBulkActions.propTypes = {
  selectedRows: PropTypes.instanceOf(ImmutableSet).isRequired,
  selectedEverything: PropTypes.bool,
  isRestore: PropTypes.bool
};
export default ReportBulkActions;